const escalationMatrixData = (state = null, action) => {
  if (action.type === "SET_ESCALATION_MATRIX_DATA") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_ESCALATION_MATRIX_DATA": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default escalationMatrixData;
